import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface TruncatedTextProps {
  text: string;
  className?: string;
  maxWidth?: string;
  tooltipSide?: "top" | "right" | "bottom" | "left";
  tooltipAlign?: "start" | "center" | "end";
}

const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  className = "",
  maxWidth = "full",
  tooltipSide = "top",
  tooltipAlign = "center",
}) => {
  if (!text) return null;
  
  // Handle both Tailwind classes and direct CSS values
  const maxWidthStyle = maxWidth.startsWith('[') && maxWidth.endsWith(']') 
    ? { maxWidth: maxWidth.substring(1, maxWidth.length - 1) }
    : {};
  
  // Use Tailwind class if not using a direct CSS value
  const maxWidthClass = maxWidth.startsWith('[') ? '' : `max-w-${maxWidth}`;
  
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div 
            className={`truncate ${maxWidthClass} ${className}`}
            style={maxWidthStyle}
          >
            {text}
          </div>
        </TooltipTrigger>
        <TooltipContent 
          side={tooltipSide} 
          align={tooltipAlign} 
          className="max-w-[250px] break-words"
        >
          <p className="text-xs">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { TruncatedText }; 